<script>
import Button from "@core/components/common/Button.vue";
import { BFormGroup, BBadge, BRow, BCol, } from 'bootstrap-vue'
import { VueAutosuggest } from 'vue-autosuggest'
import {SubstanceApi} from "@core/api";
import AddSubstanceModal from "@/views/product/components/product-card/AddSubstanceModal.vue";

export default {
    props: {
        isSelected: {
            default() {
                return () => false;
            }
        },
        inputLabel: {
            default() {
                return 'Search substances'
            }
        }
    },
    components: {AddSubstanceModal, Button, BFormGroup, VueAutosuggest, BBadge, BRow, BCol,},
    data() {
        return {
            suggestions: [],
            searchTimer: null,
            inputProps: {
                class: 'form-control w-100',
            },
        }
    },
    methods: {
        addSubstance() {
            this.$refs.addSubstanceModal.show();
        },
        getSuggestionValue() {
            return '';
        },
        include(s) {
            this.$emit('include', s);
        },
        findSubstance(qs) {
            if (!qs) {
                return;
            }

            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                SubstanceApi.search(qs).then(r => {
                    this.suggestions = [{
                        data: r.data.map(item => {
                            item.configuration = {};
                            item.details = [];
                            return item;
                        }),
                    }];
                });
            }, 600);
        },
    }
}
</script>

<template>
    <div>
        <AddSubstanceModal
            ref="addSubstanceModal"
            @created="include"
        />
        <b-row>
            <b-col md="10" lg="9">
                <b-form-group :label="inputLabel">
                    <vue-autosuggest
                        :suggestions="suggestions"
                        :input-props="{placeholder: $t('Component(Composition):search-placeholder'), class: 'form-control w-100',}"
                        :get-suggestion-value="getSuggestionValue"
                        @selected="(item) => include(item.item)"
                        @input="findSubstance"
                    >
                        <div slot-scope="{suggestion}">
                            <div>
                                <div class="pb-1">
                                    <strong>{{suggestion.item.title}}</strong>
                                </div>
                                <div>
                                    <b-badge variant="success" class="mr-1" v-if="isSelected(suggestion.item)">
                                        selected
                                    </b-badge>
                                    <b-badge class="mr-1">CAS: {{ suggestion.item.cas }}</b-badge>
                                    <b-badge>EC: {{ suggestion.item.ec }}</b-badge>
                                </div>
                            </div>
                        </div>
                    </vue-autosuggest>
                </b-form-group>
            </b-col>
<!--            <b-col md="1" lg="1" class="d-flex align-items-end justify-content-center pb-2 text-center">{{ $t('Component(Text):or') }}</b-col>-->
            <b-col md="2" lg="3" class="d-flex align-items-end pb-1">
                <Button :block="true" @click="addSubstance">{{ $t('Component(Button):add-substance') }}</Button>
            </b-col>
        </b-row>
    </div>
</template>

<style scoped lang="scss">

</style>
